export default "__VITE_ASSET__ebf4112d__"